import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-uploaded-file-icon',
  templateUrl: './files-uploaded-file.component.html'
})
export class FilesUploadedFileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
